import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { PlateFailReason, PlateUpdateFailReason } from "ipctg-inflow-types/InFlowEnums";
import type {
  ParkPlatePOSTErrorResponse,
  ParkPlatePOSTRequest,
  ParkPlatePOSTSuccessResponse,
  ParkPlateUpdatePOSTErrorResponse,
  ParkPlateUpdatePOSTRequest,
  ParkPlateUpdatePOSTSuccessResponse,
} from "ipctg-inflow-types/InFlowParkAPI";

export const fetchPlate = async (requestData: ParkPlatePOSTRequest): Promise<ParkPlatePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPlatePOSTSuccessResponse>("/plate", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkPlatePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PlateFailReason.SystemError };
  }
};

export const updatePlate = async (requestData: ParkPlateUpdatePOSTRequest): Promise<ParkPlateUpdatePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPlateUpdatePOSTSuccessResponse>("/plate-update", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkPlateUpdatePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PlateUpdateFailReason.SystemError };
  }
};
